let UNIQUE_ID_COUNTER = 0

export function getUniqueID() {
  UNIQUE_ID_COUNTER += 1
  return UNIQUE_ID_COUNTER.toString()
}
